import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hidden",
  "use": "icon-hidden-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-hidden\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M11,14.69l-.43,1.63L9.46,16l.43-1.63a6.14,6.14,0,0,1-1.79-1L6.9,14.56l-.78-.78,1.19-1.2A6.12,6.12,0,0,1,6,9.77l.5-.09a9.43,9.43,0,0,0,11,0l.5.09a6.12,6.12,0,0,1-1.31,2.81l1.19,1.2-.78.78-1.2-1.19a6.14,6.14,0,0,1-1.79,1L14.54,16l-1.07.29L13,14.69A6.05,6.05,0,0,1,11,14.69Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol